import { apiInstance } from "api/config/axios";
import { IApiResponse } from "api/models/IApiResponse";
import { getApiResponseData } from "api/services/api-service";
import { IInitiateUploadRequest } from "api/models/request/IInitiateUploadRequest";
import { IInitiateUploadResponse } from "api/models/response/IInitiateUploadResponse";
import { IUploadChunkResponse } from "api/models/response/IUploadChunkResponse";
import { IUploadStatusResponse } from "api/models/response/IUploadStatusResponse";
import { ICompleteUploadResponse } from "api/models/response/ICompleteUploadResponse";

const uploadApiBaseUrl = "/chunkedupload";

const handleApiError = (error: any): IApiResponse<any> => ({
    success: false,
    data: undefined,
    status: error.response?.status || 500,
    message: error.response?.statusText || "An error occurred",
    errors: error.response?.data?.errors || [{ code: "UnknownError", description: "Unexpected error" }],
});

export const initiateChunkedUpload = (workspaceId: string, request: IInitiateUploadRequest): Promise<IApiResponse<IInitiateUploadResponse>> => {
    return apiInstance
        .post(`${uploadApiBaseUrl}/workspaces/${workspaceId}/initiate`, request)
        .then((response) => getApiResponseData(response))
        .catch(handleApiError);
};

export const uploadChunk = (workspaceId: string, sessionId: string, chunkIndex: number, chunkData: ArrayBuffer, onUploadProgress?: (progressEvent: any) => void): Promise<IApiResponse<IUploadChunkResponse>> => {
    return apiInstance
        .put(
            `${uploadApiBaseUrl}/workspaces/${workspaceId}/sessions/${sessionId}/chunks/${chunkIndex}`,
            chunkData,
            {
                headers: { "Content-Type": "application/octet-stream" },
                onUploadProgress,
            }
        )
        .then((response) => getApiResponseData(response))
        .catch(handleApiError);
};

export const completeChunkedUpload = (workspaceId: string, sessionId: string): Promise<IApiResponse<ICompleteUploadResponse>> => {
    return apiInstance
        .post(`${uploadApiBaseUrl}/workspaces/${workspaceId}/sessions/${sessionId}/complete`)
        .then((response) => getApiResponseData(response))
        .catch(handleApiError);
};

export const getUploadStatus = (workspaceId: string, sessionId: string): Promise<IApiResponse<IUploadStatusResponse>> => {
    return apiInstance
        .get(`${uploadApiBaseUrl}/workspaces/${workspaceId}/sessions/${sessionId}/status`)
        .then((response) => getApiResponseData(response))
        .catch(handleApiError);
};

export const cancelChunkedUpload = (workspaceId: string, sessionId: string): Promise<IApiResponse<any>> => {
    return apiInstance
        .delete(`${uploadApiBaseUrl}/workspaces/${workspaceId}/sessions/${sessionId}`)
        .then((response) => getApiResponseData(response))
        .catch(handleApiError);
};